import React, { forwardRef } from 'react'

import {
  PdfViewer,
  type PdfViewerHandle,
  type PdfViewerProps,
} from '@/components/common/PdfViewerV2/PdfViewer'

import { useRefreshUrl } from '@/hooks/files/usePartialFile'

/**
 * The PDF viewer for a stored file, able to ask for a new presigned URL when
 * its range reads outlive the one it was handed. Its own component so only a
 * PDF on screen reads the signed-in user, not every host that might show one.
 */
export const StoredPdfViewer = forwardRef<
  PdfViewerHandle,
  Omit<PdfViewerProps, 'refreshUrl'> & { fileId: string }
>(({ fileId, ...props }, ref) => {
  const refreshUrl = useRefreshUrl(fileId)
  return <PdfViewer ref={ref} {...props} refreshUrl={refreshUrl} />
})

StoredPdfViewer.displayName = 'StoredPdfViewer'
